import styled from 'styled-components/macro';

const CloseButton = styled.button`
 height: 20px;
 width: 70px;
 margin-left: 100px;
 margin-top: 0px;
 margin-bottom: 0px;
 //border 1px solid red;
`;

export default {
  CloseButton,
};
